import { computed, inject, type Component, type InjectionKey, type Ref } from 'vue';

export interface ScoutForDialogs {
  trigger: Component;
  available: Readonly<Ref<boolean>>;
  open: Readonly<Ref<boolean>>;
}

export const SCOUT_FOR_DIALOGS: InjectionKey<ScoutForDialogs> = Symbol('scout-for-dialogs');

export const INSIDE_SCOUT_PANEL: InjectionKey<boolean> = Symbol('inside-scout-panel');

// Set by the MDialogShell of an MDialog when it shows the Scout trigger.
export const DIALOG_OFFERS_SCOUT: InjectionKey<Ref<boolean>> = Symbol('dialog-offers-scout');

export const OVER_SCOUT_DIALOG_CLASS = 'dialog--over-chat';

// Quasar appends dialog portals to the body as they open: the last modal one is on top.
export function isTopDialogUnderScout(): boolean {
  const dialogs = document.querySelectorAll('.q-dialog--modal');
  const top = dialogs[dialogs.length - 1];
  return top !== undefined && !top.classList.contains(OVER_SCOUT_DIALOG_CLASS);
}

export function useScoutBesideDialog() {
  const scout = inject(SCOUT_FOR_DIALOGS, null);
  const insideScout = inject(INSIDE_SCOUT_PANEL, false);

  const scoutTrigger = computed(() =>
    scout && !insideScout && scout.available.value ? scout.trigger : null,
  );
  const scoutOpen = computed(() => scout?.open.value === true);

  return { insideScout, scoutTrigger, scoutOpen };
}
